export const SERVICE_CATEGORY_TO_QUOTE_LABEL = {
  "colorbond-fencing": "Colorbond",
  "aluminium-slat-fencing-perth": "Slat fencing",
  "pool-fencing": "Pool fencing",
  "retaining-walls": "Retaining walls",
  "gates-automation": "Gates & automation",
  "security-fencing": "Security fencing",
  "blade-fencing": "Blade range",
  "asbestos-fence-removal": "Asbestos removal",
  "pvc-fencing": "PVC fencing",
  "modular-walls": "Modular walls",
};
